<div class="video-modal">
	<span *ngIf="viewport.type !== 'desktop'" class="heading fs-16px fg-purple">{{ locale.translations['n733'] }}</span>
	<button [disableRipple]="true" *ngIf="viewport.type !== 'desktop'" mat-icon-button class="close-button fg-purple" (click)="closeDialog()">
		<mat-icon>close</mat-icon>
	</button>
	<div class="video-container">
		<div id="player" class="w-100"></div>
	</div>
</div>
